<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <!--<CRenderFunction flat :content-to-render="$options.nav"/>-->

    <CSidebarNav>
      <CSidebarNavItem name="Dashboard" to="/dashboard" icon="cil-list-numbered" />
      <CSidebarNavItem name="Auction List" to="/auctionlist" icon="cil-description" />
      <CSidebarNavItem name="Auction Results" to="/auction-results" icon="cil-list" />
      <CSidebarNavTitle v-if="this.$auth.isAuthenticated">My Team</CSidebarNavTitle>
      <CSidebarNavItem v-if="this.$auth.isAuthenticated" name="Loans" to="/my-team/loans" icon="cil-group" />
      <CSidebarNavItem v-if="this.$auth.isAuthenticated" name="Transfers" to="/my-team/transfers" icon="cil-fullscreen-exit" />
      <CSidebarNavTitle v-if="this.$auth.isAuthenticated && this.$auth.user['https://tlog-online.co.uk/club_id'] == 11">Admin</CSidebarNavTitle>
      <CSidebarNavItem v-if="this.$auth.isAuthenticated && this.$auth.user['https://tlog-online.co.uk/club_id'] == 11" name="Site Variables" to="/admin/site-vars" icon="cil-group" />
      <CSidebarNavItem v-if="this.$auth.isAuthenticated && this.$auth.user['https://tlog-online.co.uk/club_id'] == 11" name="Team Admin" to="/admin/team-admin" icon="cil-fullscreen-exit" />
      <CSidebarNavItem v-if="this.$auth.isAuthenticated && this.$auth.user['https://tlog-online.co.uk/club_id'] == 11" name="Update Week" to="/admin/update-week" icon="cil-fullscreen-exit" />
      <CSidebarNavItem v-if="this.$auth.isAuthenticated && this.$auth.user['https://tlog-online.co.uk/club_id'] == 11" name="Manage Transfers" to="/admin/manage-transfers" icon="cil-fullscreen-exit" />
      <CSidebarNavItem v-if="this.$auth.isAuthenticated && this.$auth.user['https://tlog-online.co.uk/club_id'] == 11" name="Team Confirmation Report" to="/admin/team-confirmation" icon="cil-fullscreen-exit" />
    </CSidebarNav>

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}

</script>
